import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpDonutChartComponent from './adpDonutChart.component';

let adpDonutChartModule = angular.module('adpDonutChart', [
  uiRouter
])

.component('adpDonutChart', adpDonutChartComponent)

.name;

export default adpDonutChartModule;



// WEBPACK FOOTER //
// ./src/app/components/adpDonutChart/adpDonutChart.js